export default {
    namespaced: true,
    pbx_device: {
      title: "Dispositivo | Dispositivos",
      name: "nome",
      extension: "extensão",
      password: "senha",
      ha1: "HA1",
      dispatch_alarm: "gerar alarme",
      ivr: "IVR",
    },
  };
  